// @ts-nocheck

import { ListeTable } from '@mairistem/liste';
import type { ListeSort } from '@mairistem/liste/lib/ts/src/types/ListeSort';
import React from 'react';
import { useHistory } from 'react-router';
import { ProjetStatus } from '@/src/constants/projetStatus';
import type { Projet } from '@/src/interfaces/projet';

interface ProjetListeTableProps {
	items: Array<Projet>;
	count: number;
	perPage: number;
	loading: boolean;
	onLoad: (args: {
		page: number;
		perPage?: number;
	}) => Promise<Projet> | undefined;
	onSort: (sort: ListeSort) => Promise<Projet> | undefined;
	isExplorer: boolean;
}

const projetsStades = [
	'Aucun',
	'Conception',
	'Planification',
	'Exécution',
	'Soldé',
];

const ProjetListeTable = ({
	items,
	count,
	perPage,
	loading,
	onLoad,
	onSort,
	isExplorer,
}: ProjetListeTableProps) => {
	const history = useHistory();
	const handleSelect = (selectedItem) => {
		history.push(`/projets/${selectedItem?.identifiant}`);
	};

	return (
		<ListeTable
			items={items}
			loading={loading}
			count={count}
			perPage={perPage}
			onLoad={onLoad}
			onSort={onSort}
			onSelect={handleSelect}
		>
			<ListeTable.Header>
				<ListeTable.Column name="libelle" width={8} sortable>
					Intitulé
				</ListeTable.Column>
			</ListeTable.Header>

			{isExplorer && (
				<ListeTable.Header>
					<ListeTable.Column sortable name="referenceInterne" width={4}>
						Références interne
					</ListeTable.Column>

					<ListeTable.Column sortable name="status" width={4}>
						Stade
					</ListeTable.Column>
				</ListeTable.Header>
			)}
			{(projet) => (
				<div
					className={
						projet.status === ProjetStatus.CLOTURE && 'cloturedProjetRow'
					}
				>
					<ListeTable.Row>
						<ListeTable.Cell name="libelle">{projet?.libelle}</ListeTable.Cell>
						{isExplorer && (
							<>
								<ListeTable.Cell name="referenceInterne">
									{projet?.referenceInterne}
								</ListeTable.Cell>
								<ListeTable.Cell name="status">
									{projetsStades[projet.status]}
								</ListeTable.Cell>
							</>
						)}
					</ListeTable.Row>
				</div>
			)}
		</ListeTable>
	);
};

export default ProjetListeTable;
